"use client";
import { j as e } from "./jsx-runtime-CJ-St4mQ.mjs";
import { r as N, l as g, f as F, c as b, e as v, h as T } from "./Field.style-CQ8CRW6E.mjs";
import { useState as w, useCallback as E } from "react";
import { c as S, w as y } from "./capitalize-wVM0qIkw.mjs";
import { F as z, a as A, b as L } from "./FieldDescription-LT07Zs4i.mjs";
import { F as R } from "./FieldLabel-C2NVcnds.mjs";
import { F as W } from "./FieldControl-CwYVSJ2g.mjs";
const K = (m) => {
  const {
    fullWidth: k,
    maxLength: a,
    onChange: t,
    helpText: l,
    label: o,
    required: n,
    colSpan: d,
    name: i,
    id: q,
    className: h,
    rows: f = 2,
    error: r,
    ...p
  } = m, [x, C] = w(""), u = (s) => {
    a && C(s.target.value), typeof t == "function" && t(s);
  }, c = S(y(i).join(" ")), j = E(() => r || [], [r]);
  return /* @__PURE__ */ e.jsxs(
    z,
    {
      validate: r ? j : void 0,
      className: N({ colSpan: d, className: h }),
      validationMode: "onChange",
      name: i,
      children: [
        (o || c) && /* @__PURE__ */ e.jsx(R, { className: g({ required: n }), children: o || c }),
        /* @__PURE__ */ e.jsx("div", { className: F({}), children: /* @__PURE__ */ e.jsx(
          W,
          {
            onChange: u,
            required: n,
            render: (s) => /* @__PURE__ */ e.jsx(
              "textarea",
              {
                rows: f,
                maxLength: a,
                ...s,
                ...p,
                onChange: s.onChange
              }
            ),
            className: b({
              hasStartAdornment: !1,
              className: "h-auto py-2"
            })
          }
        ) }),
        /* @__PURE__ */ e.jsx(A, { className: v({}) }),
        l && /* @__PURE__ */ e.jsx(L, { className: T({}), children: l }),
        a && /* @__PURE__ */ e.jsxs("p", { className: "self-end", children: [
          x.length,
          "/",
          a
        ] })
      ]
    }
  );
};
export {
  K as default
};
